module.exports = __webpack_public_path__ + "static/media/event-services-img33.c09ea8b7.jpg";